import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../context/Auth/AuthContext';
import useMessageReactions from '../../../hooks/useMessageReactions';
import { i18n } from '../../../translate/i18n';

const MessageReaction = ({ message, classes, onReactionToggle }) => {
  const [groupedReactions, setGroupedReactions] = useState([]);
  const { user } = useContext(AuthContext);
  const { toggleReaction, loading } = useMessageReactions();

  useEffect(() => {
    console.log('🔍 DEBUG MessageReaction - useEffect triggered:', {
      messageId: message.id,
      hasReactions: !!message.reactions,
      reactionsArray: message.reactions,
      reactionsCount: message.reactions?.length || 0,
      updatedAt: message.updatedAt,
      timestamp: new Date().toISOString()
    });

    // Garantir que sempre tenhamos um array de reações
    const reactions = message.reactions || [];
    
    if (Array.isArray(reactions) && reactions.length > 0) {
      // Agrupar reações por tipo
      const grouped = reactions.reduce((acc, reaction) => {
        if (!acc[reaction.type]) {
          acc[reaction.type] = {
            type: reaction.type,
            count: 0,
            users: [],
            hasCurrentUser: false
          };
        }

        acc[reaction.type].count++;
        acc[reaction.type].users.push(reaction.userId);

        if (reaction.userId === user.id) {
          acc[reaction.type].hasCurrentUser = true;
        }

        return acc;
      }, {});

      const groupedArray = Object.values(grouped);
      console.log('🔍 DEBUG MessageReaction - Grouped reactions:', groupedArray);
      setGroupedReactions(groupedArray);
    } else {
      console.log('🔍 DEBUG MessageReaction - No reactions found');
      setGroupedReactions([]);
    }
  }, [message.reactions, message.updatedAt, message.id, user.id]);

  if (!groupedReactions.length) return null;

  const handleReactionClick = async (reactionType) => {
    if (loading) return;

    try {
      if (onReactionToggle) {
        await onReactionToggle(message.id, reactionType);
      } else {
        await toggleReaction(message.id, reactionType);
      }
    } catch (error) {
      console.error('Erro ao reagir:', error);
    }
  };

  return (
    <div className={classes.reactionWrapper}>
      {groupedReactions.map((reaction, index) => (
        <div
          key={`${reaction.type}-${index}`}
          className={`${classes.reactionBubble} ${
            reaction.hasCurrentUser ? classes.reactionBubbleActive : ''
          }`}
          onClick={() => handleReactionClick(reaction.type)}
          title={`${reaction.count} ${reaction.count === 1 ? i18n.t('messageReactions.reaction') : i18n.t('messageReactions.reactions')}${
            reaction.hasCurrentUser ? ` (${i18n.t('messageReactions.youReacted')})` : ''
          }`}
          style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
        >
          <span className={classes.reactionEmoji}>{reaction.type}</span>
          {reaction.count > 1 && (
            <span className={classes.reactionCount}>{reaction.count}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default MessageReaction;